import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getBusinessRulePendingWorkflows = async (token, params) => {
  const url = `business_rules/${params.business_rule_id}/pending_workflows`
  const data = await apiGet({ url, token, params })
  return data
}

export function useBusinessRulePendingWorkflows({ params, options = {} }) {
  const token = useContext(AuthContext)

  return useQuery(
    [
      `business_rules/${params.business_rule_id}/pending_workflows`,
      params
    ],
    () => getBusinessRulePendingWorkflows(token, params),
    { ...options }
  )
}
